/* landing-sticky-cta v3.2.0
 * v3.2.0 — Mobile showAfter cap (<750px → max 200px). Uzun sayfa + büyük customizer
 *   değeri için defensive override. Mobile UX: sticky Hero biter bitmez çıkmalı.
 * v3.1.0 — Close button + dismiss persistence:
 *   - data-lsc-close (×) button → mark dismissed.
 *   - Persistence: session | day | week. session→sessionStorage, day/week→localStorage with TTL.
 *   - Storage key namespaced per shop (window.Shopify.shop fallback to 'default').
 * v3.0.0 — Sticky ATC v2 (image + rating + AJAX submit + qty selector + hide on scroll up).
 * v2.0.0 — Custom element refactor.
 * v1.x   — Vanilla IIFE.
 */
class LandingStickyCTA extends HTMLElement {
  connectedCallback() {
    this.showAfter = parseInt(this.dataset.showAfter, 10) || 600;
    // v3.2.0 — Mobile cap: <750px'de max 200px scroll (uzun sayfa + büyük customizer
    // değeri için defensive override). Mobile UX kuralı: sticky Hero biter bitmez çıkmalı.
    if (window.matchMedia('(max-width: 749px)').matches) {
      this.showAfter = Math.min(this.showAfter, 200);
    }
    this.hideOnScrollUp = this.dataset.hideOnScrollUp === 'true';
    this.closeEnabled = this.dataset.closeEnabled === 'true';
    this.closePersistence = this.dataset.closePersistence || 'session';
    this.visible = false;
    this.lastScrollY = window.scrollY;

    if (this.closeEnabled && this._isDismissed()) {
      this.classList.add('is-dismissed');
      return;
    }

    this.onScrollBound = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScrollBound, { passive: true });
    this.onScroll();

    this._bindQty();
    this._bindSubmit();
    this._bindClose();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollBound);
  }

  onScroll() {
    const y = window.scrollY;
    const shouldShow = y > this.showAfter;

    if (shouldShow !== this.visible) {
      this.visible = shouldShow;
      this.classList.toggle('is-visible', this.visible);
      if (this.visible) this.removeAttribute('hidden');
    }

    if (this.visible && this.hideOnScrollUp) {
      const scrollingUp = y < this.lastScrollY;
      this.classList.toggle('is-hidden-up', scrollingUp);
    }

    this.lastScrollY = y;
  }

  _bindQty() {
    const qtyInput = this.querySelector('[data-lsc-qty-input]');
    if (!qtyInput) return;
    this.querySelectorAll('[data-lsc-qty]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var delta = parseInt(btn.dataset.lscQty, 10);
        var val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, val + delta);
      });
    });
  }

  _bindSubmit() {
    var submitBtn = this.querySelector('[data-lsc-submit]');
    if (!submitBtn) return;

    submitBtn.addEventListener('click', function() {
      var heroForm = document.querySelector('#landing-hero-form');
      if (!heroForm) {
        var heroSection = document.querySelector('.landing-hero-product');
        if (heroSection) heroSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      var stickyQty = document.querySelector('[data-lsc-qty-input]');
      if (stickyQty) {
        var heroQty = heroForm.querySelector('[name="quantity"]');
        if (heroQty) heroQty.value = stickyQty.value;
      }

      if (typeof heroForm.requestSubmit === 'function') {
        heroForm.requestSubmit();
      } else {
        heroForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    });
  }

  _bindClose() {
    var closeBtn = this.querySelector('[data-lsc-close]');
    if (!closeBtn) return;
    var self = this;
    closeBtn.addEventListener('click', function() {
      self._persistDismissed();
      self.classList.add('is-dismissed');
    });
  }

  _storageKey() {
    var shop = (window.Shopify && window.Shopify.shop) ? window.Shopify.shop : 'default';
    return 'landing-sticky-cta-closed:' + shop;
  }

  _isDismissed() {
    try {
      if (sessionStorage.getItem(this._storageKey())) return true;
      var raw = localStorage.getItem(this._storageKey());
      if (!raw) return false;
      var expiresAt = parseInt(raw, 10);
      if (Number.isFinite(expiresAt) && expiresAt > Date.now()) return true;
      localStorage.removeItem(this._storageKey());
    } catch (e) {
      // Storage blocked (private mode etc.) — treat as not dismissed.
    }
    return false;
  }

  _persistDismissed() {
    try {
      if (this.closePersistence === 'session') {
        sessionStorage.setItem(this._storageKey(), '1');
      } else {
        var ttl = this.closePersistence === 'week' ? 7 * 86400000 : 86400000;
        localStorage.setItem(this._storageKey(), String(Date.now() + ttl));
      }
    } catch (e) {
      // Storage blocked — dismiss is then session-only via DOM class.
    }
  }
}

if (!customElements.get('landing-sticky-cta')) {
  customElements.define('landing-sticky-cta', LandingStickyCTA);
}
